import { render, staticRenderFns } from "./LeaveRegistration.vue?vue&type=template&id=11237c85&scoped=true"
import script from "./LeaveRegistration.vue?vue&type=script&lang=js"
export * from "./LeaveRegistration.vue?vue&type=script&lang=js"
import style0 from "./LeaveRegistration.vue?vue&type=style&index=0&id=11237c85&prod&scoped=true&lang=css"
import style1 from "./LeaveRegistration.vue?vue&type=style&index=1&id=11237c85&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11237c85",
  null
  
)

export default component.exports